import { UseFormRegister, UseFormSetValue, useFieldArray, useWatch } from 'react-hook-form';
import { FC, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, IconButton, SvgIcon, Typography } from '@mui/material';
import { useNotification } from 'hooks';
import { ReactComponent as AddIcon } from 'resources/icons/add.svg';
import { MAX_SIZE_FILE } from 'utils/Constants';
import { arrayEquals } from 'utils';
import { useTranslation } from 'react-i18next';

const Files: FC<{
  index: number;
  control: any;
  setValue: UseFormSetValue<any>;
  register: UseFormRegister<any>;
  formState: any;
}> = ({ index, control, setValue, formState, register }) => {
  const { notification } = useNotification();
  const [fileExist, setFileExist] = useState(false);
  const { t } = useTranslation();
  const files = useWatch({ control, name: `addRelative.${index}.files` });
  const inputFile = useRef<HTMLInputElement>(null);

  const { fields, remove } = useFieldArray({
    control,
    name: `addRelative.${index}.files`,
  });

  const addRelativeOnClick = () => {
    inputFile.current?.click();
  };

  const onChangeFile = async (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const newFile = event.target.files[0];
    if (newFile && (!(newFile.type === 'application/pdf' || newFile.type.startsWith('image/')) || newFile.size > MAX_SIZE_FILE)) {
      notification(t('appointment.book.steps.reasons.medical_acts.notification.errorOnUploading'), 'error');
      setFileExist(false);
    } else {
      setValue(`addRelative.${index}.files`, [...files, newFile]);
      setFileExist(true);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography variant='h3'>
          {`${t('profile.relatives.add.form.upload_identity_certificate')}`}
          <input type='file' {...register(`addRelative.${index}.files`, { required: true, onChange: onChangeFile })} ref={inputFile} style={{ display: 'none' }} />
          <IconButton sx={{ ml: 2 }} onClick={addRelativeOnClick}>
            <SvgIcon component={AddIcon} inheritViewBox></SvgIcon>
          </IconButton>
        </Typography>
        {formState.errors?.addRelative?.[index]?.files && files?.length === 1 && (
          <Typography variant='body2' color='error'>
            {t('preregistration.myData.form.error.invalidFile')}
          </Typography>
        )}
      </Grid>
      {fileExist ? (
        <Grid item xs={12}>
          {files?.map((file: any, key: any) => (
            <div key={key}>
              {file.name && (
                <Grid sx={{ mb: 1, border: '2px solid', borderRadius: 4, p: 2 }} item key={key} xs={12} display='flex' justifyContent='space-between' alignItems='center'>
                  <>
                    <Typography variant='body1' sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                      {file?.name}
                    </Typography>
                    <IconButton
                      onClick={() => {
                        if (fields.length === 0 && !arrayEquals(files[key], Array(undefined))) {
                          setValue(`addRelative.${index}.files.${key}`, [undefined]);
                        } else {
                          fields.length > 0 && remove(key);
                        }
                      }}
                    >
                      <SvgIcon component={CloseIcon} inheritViewBox fontSize='small'></SvgIcon>
                    </IconButton>
                  </>
                </Grid>
              )}
            </div>
          ))}
        </Grid>
      ) : null}
    </>
  );
};
export default Files;
